<script setup lang="ts">
const props = defineProps<{
  platform?: string;
  label: string;
  iconName: string;
  active: boolean;
  feature?: boolean;
  color?: string;
  isNavbarExpanded?: boolean;
  isUppercase?: boolean;
}>();
const iconFolderPath = computed(() => {
  if (!props.active) return "inactive";
  return "active";
});

const iconColor = computed(() => {
  if (!props.active) return "#8997A9";
  return props.color || "#042B5F";
});

const getIconName = (iconName: string | undefined) => iconName?.toLowerCase() || "personal";

const labelClasses = computed(() => {
  return {
    "text-ppa-dark-blue font-extrabold": props.active,
    "text-ppa-inactive font-semibold": props.feature && !props.active,
    "text-ppa-inactive font-bold": !props.active && !props.feature,
    "uppercase": props.isUppercase
  };
});
</script>
<template>
  <template v-if="feature">
    <div class="flex items-center" :title="label">
      <IconComment v-if="iconName === 'comments'" :color="iconColor" />
      <IconMail v-else-if="iconName === 'dms'" :color="iconColor" />
      <IconPost v-else-if="iconName === 'posts'" :color="iconColor" />
      <IconUser v-else-if="iconName === 'userlist'" :color="iconColor" />
      <IconComment v-else-if="iconName === 'threads'" :color="iconColor" />

      <div class="ml-2 text-[15px]"
        :class="labelClasses"
        :aria-label="label"
        v-show="isNavbarExpanded" 
      >
        {{ label }}
      </div>
    </div>
  </template>
  <template v-else>
    <div class="flex items-center" :title="label">
      <img
        :src="`/icons/${iconFolderPath}/${getIconName(iconName)}.svg`"
        :alt="`${iconName}-icon`"
        aria-hidden="true"
      />
      <div class="ml-2 whitespace-nowrap uppercase"
        :class="labelClasses"
        :aria-label="label"
        v-show="isNavbarExpanded"
      >
        {{ label }}
      </div>
    </div>
  </template>
</template>
<style scoped>
.router-link-exact-active {
  font-weight: 900;
  color: #042b5f;
}
</style>
